import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
export function OpeningHook() {
  return <section className="py-16 px-4 relative" data-id="element-204">
      <div className="max-w-4xl mx-auto" data-id="element-205">
        <div className="relative p-8 md:p-12 glass-card shadow-2xl rounded-xl" data-id="element-206">
          {/* Decorative corners */}
          <div className="absolute top-0 left-0 w-8 h-8 border-t-2 border-l-2 border-gold-600 rounded-tl-xl" data-id="element-207"></div>
          <div className="absolute top-0 right-0 w-8 h-8 border-t-2 border-r-2 border-gold-600 rounded-tr-xl" data-id="element-208"></div>
          <div className="absolute bottom-0 left-0 w-8 h-8 border-b-2 border-l-2 border-gold-600 rounded-bl-xl" data-id="element-209"></div>
          <div className="absolute bottom-0 right-0 w-8 h-8 border-b-2 border-r-2 border-gold-600 rounded-br-xl" data-id="element-210"></div>

          <div className="flex items-start gap-8" data-id="element-211">
            <div className="space-y-5" data-id="element-212">
              <p className="text-xl md:text-2xl font-serif leading-relaxed text-zinc-100" data-id="element-213">
                <span className="text-transparent bg-clip-text bg-gold-gradient font-black text-6xl md:text-7xl float-left mr-4 leading-[0.8] mt-2" data-id="element-214">
                  O
                </span>
                n September 10, 2025, the crack of a gunshot in a Utah
                auditorium wasn't just meant to silence one man; it was meant to
                amputate the tongue of an entire generation. In that instant,
                the debate ended and the resistance began. That bullet was no
                accident — it was the logical conclusion of years of
                dehumanization, censorship algorithms, and hatred cultivated in
                the shadows of power.
              </p>

              <p className="text-lg text-zinc-400 leading-relaxed" data-id="element-215">
                If you've ever felt you had to measure your words at work, at
                university, or even in front of your own family to avoid being
                "canceled," you already know what it's like to live in the
                prelude to total silence.
              </p>

              <div className="mt-6 p-5 bg-gold-950/30 border border-gold-800/50 rounded-lg flex gap-4 items-start" data-id="element-216">
                <AlertTriangleIcon className="w-8 h-8 text-gold-500 flex-shrink-0" data-id="element-217" />
                <div data-id="element-218">
                  <h4 className="text-gold-400 font-bold uppercase tracking-wider mb-2 text-sm" data-id="element-219">
                    Warning
                  </h4>
                  <p className="text-lg font-medium text-gold-50" data-id="element-220">
                    This information has a shelf life. This book is not just a
                    story; it's the exclusive map so you never have to stay
                    silent. Read it before it disappears.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}